import { Box, styled } from '@mui/material';

import { Footer } from '@mopla/ui';

export const FooterStyled = styled(Footer)({
	'&.mobile': { borderRadius: '16px 16px 0 0' },
});

export const IconWrapper = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: number }>(({ size = 48 }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexShrink: 0,
	width: size,
	height: size,
	'& svg, & img': {
		width: size,
		height: size,
	},
}));
